import { motion } from 'framer-motion'
import { useInView } from 'framer-motion'
import { useRef } from 'react'
import type { Values as ValuesType } from '../types/content'
import { Award, Handshake, Users, FileText, CreditCard, Clock, ShieldCheck, TrendingUp } from './Icons'

interface ValuesProps {
  data: ValuesType
}

const iconMap: Record<string, React.ReactNode> = {
  award: <Award className="w-10 h-10" />,
  handshake: <Handshake className="w-10 h-10" />,
  users: <Users className="w-10 h-10" />,
  'file-text': <FileText className="w-10 h-10" />,
  'credit-card': <CreditCard className="w-10 h-10" />,
  clock: <Clock className="w-10 h-10" />,
  'shield-check': <ShieldCheck className="w-10 h-10" />,
  'trending-up': <TrendingUp className="w-10 h-10" />,
}

export default function Values({ data }: ValuesProps) {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, margin: '-100px' })

  return (
    <section id="values" className="section" ref={ref}>
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
          className="section-header"
        >
          <h2 className="section-title">{data.title}</h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {data.items.map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.2 + index * 0.1 }}
              className="text-center p-8"
            >
              <div className="w-20 h-20 flex items-center justify-center bg-primary/10 rounded-full text-primary mx-auto mb-6">
                {iconMap[item.icon] || <Award className="w-10 h-10" />}
              </div>
              <h3 className="text-xl font-semibold mb-3">{item.title}</h3>
              <p className="text-gray-400">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
